module.exports = __webpack_public_path__ + "img/butterfly_romp.5425ed07.png";